module.exports = __webpack_public_path__ + "img/amazon-alexa.8f92c2e6.png";